import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessNoOperados } from '../utils/gestionCampanaAccess'

const RequireNoOperadosAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessNoOperados(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireNoOperadosAccess
